import { CompanyFilterBaseDataProvider } from './CompanyFilterBaseDataProvider';
import { GetTargetsRequest, GetTargetsResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';
import { ConsoleRequest, DataProviderType } from 'apps/webcomponents/src/utils/request';
import { CompanyMethod } from 'apps/webcomponents/src/accounts/common/types/AccountAvailableCompanies';
import { DEFAULT_DATA_LIMIT } from '../../gzSingleSelectComplex/types';

export class CompanyFilterAccountsDataProvider extends CompanyFilterBaseDataProvider {
  async getInitialTargets(request: GetTargetsRequest): Promise<GetTargetsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: CompanyMethod.GET_USER_FORM_AVAILABLE_COMPANIES,
        payload: {
          page: 1,
          limit: DEFAULT_DATA_LIMIT,
        },
      });

      const targets = response.data.map(({
        _id,
        name,
      }) => ({
        companyId: _id,
        companyName: name,
      }));

      const userCompany = {
        companyId: this.dependencies.getUser().company.id,
        companyName: this.dependencies.getUser().company.name,
      };

      // Check if the targets array already contains the user company
      const exists = targets.some(target => target.companyId === userCompany.companyId);
      if (!exists) {
        targets.push(userCompany);
      }

      return {
        defaultTarget: [],
        targets: targets,
        totalCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getCompanies({ companyName, page, limit }: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: CompanyMethod.GET_USER_FORM_AVAILABLE_COMPANIES,
        payload: {
          page: page,
          limit: limit ?? DEFAULT_DATA_LIMIT,
          companyName: companyName
        },
      });

      return {
        targets: response.data.map(({ _id, name }) => ({ companyId: _id, companyName: name })),
        totalCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
